import { useCallback } from "react";

import { UISearchMinPriceInfo } from "@flights/types";
import useCreateUrl from "hooks/useCreateUrl";
// eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
import { useStore } from "../../../store";

export const useCreateFlexUrl = () => {
  const { createUrlWithApiPrefix } = useCreateUrl();
  // eslint-disable-next-line import/no-deprecated -- this line was auto generated, hence fix the issue timely
  const store = useStore();

  const {
    search: { type, searchSegments }
  } = store;

  const createUrl = useCallback(
    (flexDate: UISearchMinPriceInfo) => {
      const { offsetDays, departureDate, returnDate, accuracyTrackerId } = flexDate;
      const searchParams = new URLSearchParams(location.search);

      switch (type) {
        case "ROUNDTRIP":
          searchParams.set("depart", departureDate);
          returnDate && searchParams.set("return", returnDate);
          break;
        case "ONEWAY":
          searchParams.set("depart", departureDate);
          break;
        case "MULTISTOP":
          const currentDates = searchSegments.map((segment, index) => {
            if (index === 0) {
              return departureDate;
            }
            if (index === searchSegments.length - 1) {
              return returnDate;
            }
            const date = new Date(segment.departureDate || "");
            date.setDate(date.getDate() + offsetDays);
            return date.toISOString().split("T")[0];
          });
          searchParams.set("multiStopDates", currentDates.join("|"));
          break;
        default:
          break;
      }

      const from = searchParams.get("from");
      const to = searchParams.get("to");

      if (accuracyTrackerId) {
        searchParams.set("offerAccuracyTrackerId", accuracyTrackerId);
      }

      const url = `/flights/${from}-${to}/?` + searchParams.toString();

      return createUrlWithApiPrefix(url);
    },
    [createUrlWithApiPrefix, searchSegments, type]
  );

  return { createUrl };
};
